import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-delete',
	path: '/secure/project/DeleteProjectRole([!%]?[\\w]*).jspa',
};
